import { combineReducers } from 'redux';

import letterhistoryreport from './letterhistoryreport/reducer';

export default combineReducers({
  letterhistoryreport,
});



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/state/reducer.js